import type { LabelCategory } from '../../api/labels'
import styles from './labelUiStyles.module.css'

const categoryClassByLabelCategory: Record<LabelCategory, string> = {
  energy: styles.chipEnergy ?? '',
  genre: styles.chipGenre ?? '',
  instrument: styles.chipInstrument ?? '',
  language: styles.chipLanguage ?? '',
  mood: styles.chipMood ?? '',
  rhythm: styles.chipRhythm ?? '',
  tempo: styles.chipTempo ?? '',
  texture: styles.chipTexture ?? '',
  use_case: styles.chipUseCase ?? '',
  vocal_presence: styles.chipVocalPresence ?? ''
}

export const labelUiClass = (...classNames: Array<string | false | null | undefined>): string =>
  classNames.filter(Boolean).join(' ')

export const labelChipClassName = (category: LabelCategory): string =>
  labelUiClass(styles.chip ?? '', categoryClassByLabelCategory[category])

export const labelMoreClassName = styles.more ?? ''
export const labelUiStyles = styles
